<template>
    <div class='bar-box'>
        <div class="progress-all" :class="{'warning':parseInt(row[column.warningPercentage]) && parseInt(row[column.percentage]||0)>parseInt(row[column.warningPercentage]||0)}">
            <div class="progress" :style="{width:parseInt(row[column.percentage]||0)+'%'}">{{parseInt(row[column.progressNum]||0)}}</div>
            <span class="all-text" v-if="row[column.allNum]">{{parseInt(row[column.allNum])}}</span>
            <div class="threshold" :style="{left:parseInt(row[column.warningPercentage])+'%'}" v-if="row[column.warningPercentage]"></div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'skyProgressBar',
    componentName: 'skyProgressBar',
    props:{
        column:{type: Object},
        row:{type: Object},
    }
}
</script>
<style>
.bar-box{
    height: 30px;
    line-height: 30px;
    padding-top:10px;
    font-size:10px;
}
.progress-all{
    width: 80%;
    height: 12px;
    border: 1px solid rgb(4, 250, 37);
    position: relative;
    color:rgb(13, 240, 43);
    border-radius: 5px;
    box-sizing: border-box;
}
.progress-all .progress{
    height: 10px;
    background-color: rgba(10, 175, 32);
    text-align: center;
    border-radius: 5px;
    line-height: 10px;
    color:#fff;
    margin-left: -1px;
}
.progress-all.warning{
    border-color:  rgb(240, 13, 13);
    color:  rgb(240, 13, 13);
}
.progress-all.warning .progress{
    background-color: rgb(240, 13, 13);
}
.all-text{
    position: absolute;
    left:100%;
    padding-left:10px;
    top:-10px;
}
.threshold{
    width: 1.5px;
    height: 10px;
    background-color: rgb(241, 221, 40);
    position: absolute;
    top:0;
}
</style>


// WEBPACK FOOTER //
// src/components/controls/progressBar.vue